import { render, staticRenderFns } from "./ProjectPublishing.vue?vue&type=template&id=34573d35&scoped=true&"
import script from "./ProjectPublishing.vue?vue&type=script&lang=js&"
export * from "./ProjectPublishing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34573d35",
  null
  
)

export default component.exports